<template>
  <div>
    <b-button squared :variant="buttonVariant" :class="['w-100 d-flex justify-content-between align-items-center', buttonClass]" v-b-toggle="toggleId">
      <div class="d-flex align-items-center">
        <span :class="headerClass">{{ header }}</span>
        <span v-if="headerDescription"
              v-b-tooltip.hover.nofade="toolTipDelay"
              :title="headerDescription"
              class="ms-2">
          <font-awesome-icon :icon="['fas', 'info-circle']" />
        </span>
      </div>
      <font-awesome-icon size="lg" :icon="['far', internalValue ? 'caret-circle-up' : 'caret-circle-down']" />
    </b-button>

    <b-collapse :id="toggleId" :accordion="accordion"
                v-model="internalValue"
                @hidden="$emit('hidden', $event)"
                @shown="$emit('shown', $event)">
      <div :class="contentClass">
        <slot></slot>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import AppConfig from '@/mixins/AppConfig-APP_TARGET';
import UniqueId from '@/mixins/UniqueId';

export default {
  name: "CollapsiblePanel",

  mixins: [ AppConfig, UniqueId ],

  props: {
    value: { type: Boolean, default: false },
    buttonVariant: { type: String, default: 'primary' },
    buttonClass: { type: String, default: 'text-start' },
    header: { type: String, default: null },
    headerClass: { type: String, default: null },
    headerDescription: { type: String, default: null },
    contentClass: { type: String, default: 'mt-2'},
    accordion: { type: String, default: null },
  },

  data() {
    return {
      internalValue: this.value
    };
  },

  computed: {
    toggleId() {
      return `collapse-panel-${this.uniqueId}`;
    },
  },

  watch: {
    value(newVal) {
      if (newVal !== this.internalValue) {
        this.internalValue = newVal;
      }
    },

    internalValue(newVal, oldVal) {
      this.$emit("input", newVal);
    },
  },

  methods: {
  }
}
</script>
